import { createClient } from '@supabase/supabase-js'
import { Database } from 'src/database.types'
const supabase = createClient<Database>(
	'https://vmmczjcmawxzvoswwuvs.supabase.co',
	process.env.REACT_APP_SUPABASE_ANON_KEY!,
)

export const register = async ({
	id,
	email,
	password,
	firstName,
	lastName,
	language,
	sendConfirmEmail = true,
}: // uid,
// salt,
// hash,
// status,
// god,
// created_at,
// updated_at,
{
	email: string
	password: string
	firstName: string
	lastName: string
	language: string
	sendConfirmEmail?: boolean
	id?: string
	uid?: string
	salt?: string
	hash?: string
	status?: string
	god?: boolean
	created_at?: string
	updated_at?: string
}) => {
	const { data, error } = await supabase.auth.signUp({
		// Ensure the email field exists in the database schema or remove this line if not applicable
		email: email,
		password: password,
		options: {
			data: {
				firstName,
				lastName,
				language,
				sendConfirmEmail: sendConfirmEmail,
			},
		},
	})
	return { data, error }
}
export const login = async ({
	email,
	password,
}: {
	email: string
	password: string
}) => {
	const { data, error } = await supabase.auth.signInWithPassword({
		email,
		password,
	})
	if (error) {
		throw new Error(error.message)
	}

	return data
}
export const refreshToken = async () => {
	const { data, error } = await supabase.auth.getSession()

	if (error) {
		throw new Error(error.message)
	}

	return data
}
export const deleteUser = async (userId: string) => {
	const { data, error } = await supabase.auth.admin.deleteUser(userId)
	if (error) {
		throw new Error(error.message)
	}

	return data
}
export const forgotPassword = async (email: string) => {
	const { data, error } = await supabase.auth.admin.generateLink({
		type: 'recovery',
		email: email,
	})
	if (error) {
		throw new Error(error.message)
	}

	return data
}
export const updatePasswordSupabase = async (
	id: string,
	newPassword: string,
) => {
	const { data: user, error } = await supabase.auth.admin.updateUserById(id, {
		password: newPassword,
	})
	if (error) {
		throw new Error(error.message)
	}

	return user
}
export const logOut = async () => {
	const { error } = await supabase.auth.signOut()
	if (error) {
		throw new Error(error.message)
	}
	return true
}

export const sendUpdateEmail = async ({ email }: { email: string }) => {
	const { data, error } = await supabase.auth.updateUser({
		email: email,
	})
	if (error) {
		throw new Error(error.message)
	}
	return data
}
export async function checkCurrentPasswordSupabase({
	email,
	currentPassword,
}: {
	email?: string | null
	currentPassword: string
}) {
	if (!email) {
		return { currentPasswordVerification: false }
	}
	const { error } = await supabase.auth.signInWithPassword({
		email,
		password: currentPassword,
	})

	if (error) {
		return { currentPasswordVerification: false }
	}

	return { currentPasswordVerification: true }
}

export const signInWithMagicLink = async (
	email = '',
	fallbackUrl = window.location.origin + '/verify/',
	returnLink = false,
) => {
	const { data, error } = await supabase.functions.invoke(
		'signInWithMagicLink',
		{
			body: JSON.stringify({
				email: email.trim(),
				fallbackUrl,
				returnLink,
				isDashboard: false,
			}),
		},
	)

	if (error) throw error

	return data
}
// /verify/xxxxxxxxxx
export const varifyUser = async ({ token }: { token: string }) => {
	const { data, error } = await supabase.auth.verifyOtp({
		token_hash: token,
		type: 'email',
	})
	if (error) throw error

	return data
}
// const { data, error } = await supabase.auth.verifyOtp({
// 	token_hash: params.token,
// 	type: "email",
// });

// export const checkEmail = async (email: string) => {
// 	const { data, error } = await supabase.auth.getUserIdentities()
// 		.from('users')
// 		.select('email')
// 		.eq('email', email)
// 		.single()
// 	if (error) {
// 		throw new Error(error.message)
// 	}

// 	return data

// }
export const insertIntoUser = async ({
	// id,
	email,
	// uid,
	salt,
	hash,
	status,
	god,
	createdAt,
	updatedAt,
}: {
	id?: string
	email: string
	uid?: string
	salt: string
	hash: string
	status: string
	god: boolean
	createdAt: string
	updatedAt: string
	firstName: string
	lastName: string
	password: string
	language: string
}) => {
	const { data, error } = await supabase
		.from('User')
		.insert({
			email: (await supabase.auth.getUser()).data.user?.email || '',
			createdAt,
			god,
			hash,
			id: (await supabase.auth.getUser()).data.user?.id || '',
			salt,
			status,
			uid:
				(
					await supabase.auth.getUser()
				).data.user?.email?.split('@')?.[0] ?? email.split('@')?.[0],
			updatedAt,
		})
		.select()
		.maybeSingle()
	if (error) {
		console.log({ error })
		throw new Error(error.message)
	}
	return { data, error }
}

export const insertIntoProfile = async ({
	// id,
	firstName,
	lastName,
	// user,
	createdAt,
	updatedAt,
}: {
	id?: string
	firstName: string
	lastName: string
	user?: string
	createdAt: string
	updatedAt: string
}) => {
	const { data, error } = await supabase.from('Profile').insert({
		id: String(Math.random()),
		firstName,
		lastName,
		user: (await supabase.auth.getUser()).data.user?.id,
		createdAt,
		updatedAt,
	})
	if (error) {
		// throw new Error(error.message)
		console.log({ error })
	}
	return { data, error }
}
